import ActionTypes from '../constants/action-types';

export const getUserLists = (args) => async (dispatch) => {
    dispatch({
        type: ActionTypes.SET_USER_LISTS_BUSY,
        payload: true
    });
    await axios.get(`/api/user-lists`, { params: { ...args } })
        .then((response) => {
            dispatch({
                type: ActionTypes.SET_USER_LISTS_HAS_MORE,
                payload: response.data.data && response.data.data.length >= args.per_page
            });

            dispatch({
                type: ActionTypes.SET_USER_LISTS_TOTAL,
                payload: response.data.total
            });

            dispatch({
                type: args.action === ActionTypes.SET_USER_LISTS
                    ? ActionTypes.SET_USER_LISTS
                    : ActionTypes.APPEND_USER_LISTS,
                payload: response.data.data
            });

            dispatch({
                type: ActionTypes.SET_USER_LISTS_BUSY,
                payload: false
            });
        })
        .catch((error) => {
            console.error({ error });
            dispatch({
                type: ActionTypes.SET_USER_LISTS_BUSY,
                payload: false
            });
        });
};

export const getUserListUsers = (args) => async (dispatch) => {
    dispatch({
        type: ActionTypes.SET_USER_LIST_USERS_BUSY,
        payload: true
    });
    await axios.get(`/api/user-list-users/${args.id}`, {
        params: {
            ...args
        }
    })
        .then((response) => {
            dispatch({
                type: args.action === ActionTypes.SET_USER_LIST_USERS_BUSY
                    ? ActionTypes.SET_USER_LIST_USERS_BUSY
                    : ActionTypes.APPEND_USER_LIST_USERS,
                payload: response.data.data
            });

            dispatch({
                type: ActionTypes.SET_USER_LIST_USERS_TOTAL,
                payload: response.data.total
            });

            dispatch({
                type: ActionTypes.SET_USER_LIST_USERS_BUSY,
                payload: false
            });
        })
        .catch((error) => {
            console.error({ error });
            dispatch({
                type: ActionTypes.SET_USER_LIST_USERS_BUSY,
                payload: false
            });
        });
};

export const setActiveUserList = payload => {
    return {
        type: ActionTypes.SET_ACTIVE_USER_LIST,
        payload
    };
};

export const setUserListsPage = payload => {
    return {
        type: ActionTypes.SET_USER_LIST_PAGE,
        payload
    };
};

export const setUserListUserPage = payload => {
    return {
        type: ActionTypes.SET_USER_LIST_USER_PAGE,
        payload
    };
};

export const setUserListsTotal = payload => {
    return {
        type: ActionTypes.SET_USER_LISTS_TOTAL,
        payload
    };
};

export const deleteUserListUser = payload => {
    return {
        type: ActionTypes.REMOVE_USER_LIST_USER,
        payload
    };
};

export const resetUserListUsers = payload => {
    return {
        type: ActionTypes.RESET_USER_LIST_USERS,
        payload
    };
};

export const prependUserLists = payload => {
    return {
        type: ActionTypes.PREPEND_USER_LISTS,
        payload
    };
};

export const resetUserLists = payload => {
    return {
        type: ActionTypes.RESET_USER_LISTS,
        payload
    };
};

export const removeUserLists = payload => {
    return {
        type: ActionTypes.REMOVE_USER_LIST,
        payload
    };
};

export const updateUserLists = payload => {
    return {
        type: ActionTypes.UPDATE_USER_LIST,
        payload
    };
};

export const appendUserListUsers = payload => {
    return {
        type: ActionTypes.APPEND_USER_LIST_USERS,
        payload
    };
};

export const toggleUserListModal = payload => {
    return {
        type: ActionTypes.TOGGLE_USER_LIST_MODAL,
        payload
    };
};